/**
 * OnboardingRouteLayout
 *
 * Minimal route layout for onboarding pages.
 * Does NOT include sidebar or header - only the basic page structure.
 *
 * This is separate from the component-level OnboardingLayout which provides
 * the visual wrapper with progress steps, title, etc.
 *
 * Used in router.tsx to ensure onboarding pages don't show AppLayout navigation.
 */

import { Outlet } from 'react-router-dom';
import { useScrollToTop } from '@/hooks/use-scroll-to-top';

export const OnboardingRouteLayout = () => {
  // Scroll to top on route change (consistent with other layouts)
  useScrollToTop();

  return (
    <>
      <Outlet />
    </>
  );
};
